import React from "react";
import { Modal, Button, Segment, Icon } from "semantic-ui-react";
import Dropzone from "react-dropzone";
import classNames from "classnames";
import { truncateGeoJSONDisplay } from "../../utils/geojsonHelper";
import { truncateKMLDisplay } from "../../utils/kmlHelper";

interface ImportLayerModalProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isImporting: boolean;
  handleFileUpload: (acceptedFiles: File[]) => void;
  handleImport: () => void;
  fileContent: Record<string, any> | null;
  originalKML: Document | null;
  fileType: "geojson" | "kml" | null;
  wipeState: () => void;
}

export function ImportLayerModal({
  isModalOpen,
  setIsModalOpen,
  isImporting,
  handleFileUpload,
  handleImport,
  fileContent,
  originalKML,
  fileType,
  wipeState,
}: ImportLayerModalProps) {
  return (
    <Modal size='small' open={isModalOpen} onClose={() => setIsModalOpen(false)} className='tw-h-[35%]'>
      <Modal.Header>Import Layer</Modal.Header>
      <Modal.Content className='tw-h-full'>
        <div className='tw-mb-4 tw-h-full'>
          <Dropzone onDrop={handleFileUpload} accept={[".json", ".geojson", ".kml"]} multiple={false}>
            {({ getRootProps, getInputProps, isDragActive }) => (
              <Segment
                {...getRootProps()}
                color={undefined}
                placeholder
                tertiary
                className={classNames({
                  "tw-h-full tw-cursor-pointer tw-rounded-lg tw-border-[3px] tw-border-dashed tw-border-black-light tw-py-12 tw-text-center":
                    true,
                  "tw-bg-blue": isDragActive,
                })}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Drop the GeoJSON or KML file here...</p>
                ) : !!fileContent ? (
                  <pre className='tw-m-0 tw-overflow-auto tw-text-left tw-text-black'>
                    {fileType === "kml" && originalKML
                      ? truncateKMLDisplay(originalKML)
                      : truncateGeoJSONDisplay(fileContent)}
                  </pre>
                ) : (
                  <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-black'>
                    <Icon name='upload' size='big' />
                    <p className='tw-mt-1 tw-text-lg'>Click or drag GeoJSON or KML file to upload</p>
                  </div>
                )}
              </Segment>
            )}
          </Dropzone>
        </div>
      </Modal.Content>
      <Modal.Actions className='tw-flex tw-justify-between'>
        <Button
          onClick={() => {
            wipeState();
            setIsModalOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button primary onClick={handleImport} disabled={!fileContent || isImporting} loading={isImporting}>
          {isImporting ? "Importing..." : "Import"}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
